(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Mobile = Lfl.Mobile || {};

    (function (Mobile, $, undefined) {
        if(Lfl.Files.isLoadedAlready(Lfl.Mobile, 'NotificationIssues')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Handles displaying mobile notification issues help page
         *
         * @memberOf Lfl.Mobile
         */
        Lfl.Mobile.NotificationIssues = Mobile.NotificationIssues || {};

        (function (NotificationIssues, $, undefined) {
            /*
            |===========================================================================================================
            | Object definition
            |===========================================================================================================
            */

            var notificationIssuesHelpUrl =  "";

            /**
             * @param parameters
             * @param parameters.notificationIssuesHelpUrl
             * @memberOf Lfl.Mobile.NotificationIssues
             */
            NotificationIssues.init = function (parameters) {
                notificationIssuesHelpUrl = parameters.notificationIssuesHelpUrl;
            };

            /*
            |-----------------------------------------------------------------------------------------------------------
            | Public methods
            |-----------------------------------------------------------------------------------------------------------
            */

            /**
             * @memberOf Lfl.Mobile.NotificationIssues
             */
            NotificationIssues.displayHelpIfNeeded = function () {
                if (typeof notificationIssuesHelpUrl === 'undefined') {
                    throw new Error("This object was not properly initialized and cannot be used in this state. Missing notificationIssuesHelpUrl value.");
                }

                const timestamp = Lfl.Mobile.Sender.getMobileNotificationsIssuesInfoPageDisplayedTimestamp();

                if (Lfl.Mobile.Sender.wasMobileNotificationsIssuesInfoPageResolved() === false && (timestamp === -1 || !isToday(timestamp))) {
                    window.location.href = notificationIssuesHelpUrl;
                }
            };

            NotificationIssues.setHelpDisplayedNow = function () {
                Lfl.Mobile.Sender.setMobileNotificationsIssuesInfoPageDisplayedTimestamp(new Date().getTime());
            };

            NotificationIssues.setHelpResolved = function () {
                Lfl.Mobile.Sender.setMobileNotificationsIssuesInfoPageResolved();
            };

            /*
            |-----------------------------------------------------------------------------------------------------------
            | Private methods
            |-----------------------------------------------------------------------------------------------------------
            */

            /* TODO Later - Cleanup::I - Simplify by using momentjs */
            function isToday (someDateTimestamp) {
                const someDate = new Date(someDateTimestamp);
                const today = new Date();
                return someDate.getDate() === today.getDate() &&
                    someDate.getMonth() === today.getMonth() &&
                    someDate.getFullYear() === today.getFullYear()
            }

        }(Mobile.NotificationIssues, jQuery));
    }(Lfl.Mobile, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));